
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Make sure we're correctly mounting the app
const rootElement = document.getElementById("lovable-sample-reviews");
if (!rootElement) throw new Error("Root element not found");

createRoot(rootElement).render(<App />);
